<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'page-new-process',
};
</script>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-new-process.vue